import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import { S3_PREFIX } from '@shared-submodule/sm-constants'
import { playerType, scoreType } from '@shared-submodule/utils'
import playerImg from '@assets/images/placeholder/playerPagePlaceholder.svg'
import CustomLink from '../customLink'
import MyImage from '@shared/components/myImage'

const PlayerCard = ({ data }) => {
  return (
    <div className={`${styles.playerCard} common-box text-center me-auto ms-auto p-0`}>
      {data?.oPlayer?.eTagStatus === 'a' ? (
        <>
          <p className={styles.type}>{playerType(data?.eType)}</p>
          <CustomLink href={data?.oPlayer?.oSeo?.sSlug ? `/${data?.oPlayer?.oSeo?.sSlug}` : ''} prefetch={false}>
            <a className={`${styles.imgBlock} d-block m-auto `}>
              <MyImage
                src={data?.oPlayer?.oImg?.sUrl ? `${S3_PREFIX}${data?.oPlayer?.oImg?.sUrl}` : playerImg}
                width="162"
                height="162"
                alt={data?.oPlayer?.oImg?.sText || 'Player Image'}
                layout="responsive"
                autoRadiusImage
              />
            </a>
          </CustomLink>
        </>
      ) : (
        <>
          <p className={styles.type}>{playerType(data?.eType)}</p>
          <div className={`${styles.imgBlock} d-block m-auto `}>
            <MyImage
              src={data?.oPlayer?.oImg?.sUrl ? `${S3_PREFIX}${data?.oPlayer?.oImg?.sUrl}` : playerImg}
              width="162"
              height="162"
              alt={data?.oPlayer?.oImg?.sText || 'Player Image'}
              layout="responsive"
              autoRadiusImage
            />
          </div>
        </>
      )}
      <h4 className="small-head mb-3 mt-4">
        {
          data?.oPlayer?.eTagStatus === 'a' ? <CustomLink
            href={`/${data?.oPlayer?.oSeo?.sSlug}`}
            prefetch={false}>
            <a className={styles.overflowEllipsis}>
              {data?.oPlayer?.sFullName || data?.oPlayer?.sFirstName}
            </a>
          </CustomLink> : data?.oPlayer?.sFullName || data?.oPlayer?.sFirstName
        } <br></br> {data?.oTeam?.sAbbr ? `(${data?.oTeam?.sAbbr.toUpperCase()})` : `(${data?.oTeam?.sCountry.toUpperCase()})`}
      </h4>
      <p className={`${styles.scoreContainer} d-flex align-items-center justify-content-center`}>
        <span className={styles.score}>
          {data?.eType === 'hrs' && data?.nRuns}
          {data?.eType === 'hs' && data?.nHighest}
          {data?.eType === 'bbf' && data?.sBestInning}
          {data?.eType === 'hwt' && data?.nWickets}
        </span>
        <span className={`${styles.stype} big-text text-secondary mt-1 ms-1 ms-lg-2`}>{scoreType(data?.eType)}</span>
      </p>
    </div>
  )
}
PlayerCard.propTypes = {
  data: PropTypes.object
}

export default PlayerCard
